function Sudan({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2222)">
  <path d="M1.58763 9.04366C0.5705 11.1472 0 13.507 0 16.0002C0 18.4933 0.5705 20.8532 1.58763 22.9567L16 24.348L30.4124 22.9567C31.4295 20.8532 32 18.4933 32 16.0002C32 13.507 31.4295 11.1472 30.4124 9.04366L16 7.65234L1.58763 9.04366Z" fill="#F0F0F0"/>
  <path d="M1.58813 22.9561C4.17601 28.308 9.65657 31.9996 15.9999 31.9996C22.3433 31.9996 27.8239 28.308 30.4117 22.9561H1.58813Z" fill="black"/>
  <path d="M1.58813 9.0435H30.4117C27.8239 3.69156 22.3433 0 15.9999 0C9.65657 0 4.17601 3.69156 1.58813 9.0435Z" fill="#D80027"/>
  <path d="M4.68628 4.68652C-1.56209 10.9349 -1.56209 21.0656 4.68628 27.314C7.26834 24.732 9.75165 22.2486 16 16.0003L4.68628 4.68652Z" fill="#496E2D"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Sudan;
